
import img1 from '../images/item/item-01.png'
import img2 from '../images/item/item-02.png'
import img3 from '../images/item/item-03.png'
import img4 from '../images/item/item-04.png'
import img5 from '../images/item/item-05.png'
import img6 from '../images/item/item-06.png'
import img7 from '../images/item/item-07.png'
import img8 from '../images/item/item-08.png'



const dataItem = [

    {
        id: 1,
        img: img1,
        title: '3D Digital Artwork',
    },
    {
        id: 2,
        img: img2,
        title: 'King Of Pirates',
    },
    {
        id: 3,
        img: img3,
        title: 'Pomeranian Doge',
    },
    {
        id: 4,
        img: img4,
        title: '3D Digital Artwork',
    },
    {
        id: 5,
        img: img5,
        title: 'Nintendo Switch',
    },
    {
        id: 6,
        img: img6,
        title: 'The Strange Art',
    },
    {
        id: 7,
        img: img7,
        title: 'Pixel Art Addicted',
    },
    {
        id: 8,
        img: img8,
        title: '3D Digital Artwork',
    },

]

export default dataItem;